/// <amd-module name="Repos/FilesHubCommon/FileEditContext" />
import { IFileEditContext } from "Repos/Files/Contracts";
import { IReadonlyObservableValue, ObservableValue } from "VSS/Core/Observable";

export class FileEditContext implements IFileEditContext {
    private originalContent: string;
    private content: string;
    private isDirty = new ObservableValue(false);
    private revertImpl: () => void;
    private commitImpl: (content: string) => void;

    constructor(originalContent: string, revert: () => void, commit: (content: string) => void) {
        this.originalContent = this.content = originalContent;
        this.revertImpl = revert;
        this.commitImpl = commit;
    }

    public commit(): void {
        this.commitImpl(this.content);
    }

    public getIsDirty(): IReadonlyObservableValue<boolean> {
        return this.isDirty;
    }

    public getContent(): string {
        return this.content;
    }

    public revert(): void {
        this.revertImpl();
    }

    public setContent(newContent: string, setOriginalContent?: boolean): void {
        this.content = newContent;

        if (setOriginalContent) {
            this.originalContent = newContent;
        }

        const dirty = newContent !== this.originalContent;
        if (dirty !== this.isDirty.value) {
            this.isDirty.value = dirty;
        }
    }
}
